import { useToast } from "@/hooks/errors/use-toast"
import { AnimatePresence } from 'framer-motion'
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  ToastIcon,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      <AnimatePresence mode="popLayout">
        {toasts.map(({ id, title, description, action, variant, ...props }) => {
          return (
            <Toast key={id} variant={variant} {...props}>
              <div className="flex items-start gap-3 flex-1 relative z-10">
                <ToastIcon variant={variant} />
                <div className="flex-1 space-y-1 min-w-0">
                  {title && <ToastTitle>{title}</ToastTitle>}
                  {description && (
                    <ToastDescription>{description}</ToastDescription>
                  )}
                </div>
                {action}
              </div>
              <ToastClose />
            </Toast>
          )
        })}
      </AnimatePresence>
      <ToastViewport />
    </ToastProvider>
  )
}
